import { lazy, Suspense, type ComponentType } from "react"

/*
 * The cache inspector, in development only: a production build drops it and its package. Its own
 * floating button would sit on the sidebar's foot or a page's header actions wherever it was
 * pinned (toasts own the bottom-right), so it sits in the sidebar's foot as a control among the
 * others instead. Its panel still opens fixed over the page.
 */
const Devtools: ComponentType = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then(({ ReactQueryDevtools }) => ({
        default: () => <ReactQueryDevtools buttonPosition="relative" />,
      })),
    )
  : () => null

/**
 * The inspector's button, in a box as wide as it and as tall as the foot's other controls. It draws
 * itself at 48px and spills above and below the box evenly, so the row keeps its production height.
 * It isn't scaled down: a transform would become the containing block of its fixed panel and
 * shrink that too.
 */
export function QueryDevtools() {
  if (!import.meta.env.DEV) return null
  return (
    <span className="flex h-7 w-12 items-center justify-center">
      <Suspense>
        <Devtools />
      </Suspense>
    </span>
  )
}
